export const data = [
  {
    title: "Useful Links",
    links: [
      {
        id: 1,
        text: "About Molla",
        link: "/",
      },

      {
        id: 2,
        text: "How to shop on Molla",
        link: "/",
      },

      {
        id: 3,
        text: "FAQ",
        link: "/",
      },

      {
        id: 4,
        text: "Contact us",
        link: "/",
      },
      {
        id: 5,
        text: "Log in",
        link: "/",
      },
    ],
  },
  {
    title: "Customer Service",
    links: [
      {
        id: 1,
        text: "Payment Methods",
        link: "/",
      },
      {
        id: 2,
        text: "Money-back guarantee!",
        link: "/",
      },
      {
        id: 3,
        text: "Returns",
        link: "/",
      },
      {
        id: 4,
        text: "Shipping",
        link: "/",
      },
      {
        id: 5,
        text: "Terms and conditions",
        link: "/",
      },
      {
        id: 6,
        text: "Privacy Policy",
        link: "/",
      },
    ],
  },
  {
    title: "My Account",
    links: [
      {
        id: 1,
        text: "Sign In",
        link: "/",
      },
      {
        id: 2,
        text: "View Cart",
        link: "/",
      },
      {
        id: 3,
        text: "My Wishlist",
        link: "/",
      },
      {
        id: 4,
        text: "Track My Order",
        link: "/",
      },
      { id: 5, text: "Help", link: "/" },
    ],
  },
];
